var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-section',[(_vm.featuredEntry)?_c('featured-entry',{attrs:{"entry":_vm.featuredEntry,"card-type":"project","before-asset-shape":"circle"}}):_vm._e(),(_vm.isPageLoaded && _vm.featuredEntryId !== null)?_c('app-elements',{attrs:{"sectionHandle":"project","cardType":"project","cardModel":"enhance","options":{
            limit: 9,
            ids: [_vm.featuredEntryId],
            idsExclude: true
        }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }